import { Community_Joining_Que_Labels_Eng, EnglishLabels, Regisration_Form_Labels_English } from "src/common/constants/englishLabels";
import { DatePicker, InputControl, MenuSelect, MultiSelect } from "src/common/formConstants";
import { DrowpdownValue, PersonalDetailsForm } from "src/types/FormTypes";
import { Genders, MaritalStatus } from "src/utils/registrationFormUtils";
import { GridItem, SimpleGrid, VStack } from "@chakra-ui/react";
import { HindiLabels, Regisration_Form_Labels_Hindi } from "src/common/constants/hindiLabels";

type PersonalDetailsProps = {
    isCurrentFormValid: boolean;
    handlePersonalDetailsChanged: (fieldName: string, value: string | DrowpdownValue[]) => void;
    personalDetailsValues: PersonalDetailsForm;
}

const PersonalDetails: React.FC<PersonalDetailsProps> = (props: PersonalDetailsProps) => {
    const { isCurrentFormValid, handlePersonalDetailsChanged, personalDetailsValues } = props;

    const interestDropdownValues = Object.values(Community_Joining_Que_Labels_Eng).map((value) => {
        return {
            label: value,
            value: value
        }
    })

    return (
        <VStack w="100%">
            <SimpleGrid width="100%" columns={[1, 1, 1, 2]} gap={[4, 4, 4, 10]}>
                <GridItem order={[1, 1, 1]}>
                    <InputControl
                        isValidate={isCurrentFormValid}
                        isMandatory={true}
                        name="fullName"
                        onChange={handlePersonalDetailsChanged}
                        value={personalDetailsValues?.fullName}
                        placeholder="Enter full name"
                        hindiLabel={Regisration_Form_Labels_Hindi.FULL_NAME}
                        englishLabel={Regisration_Form_Labels_English.FULL_NAME}
                    />
                </GridItem>

                <GridItem order={[2, 2, 2]}>
                    <InputControl
                        isValidate={isCurrentFormValid}
                        isMandatory={true}
                        onChange={handlePersonalDetailsChanged}
                        name="mothersName"
                        value={personalDetailsValues?.mothersName}
                        placeholder="Enter your mother’s full name"
                        hindiLabel={Regisration_Form_Labels_Hindi.MOTHERS_NAME}
                        englishLabel={Regisration_Form_Labels_English.MOTHERS_NAME}
                    />
                </GridItem>

                <GridItem order={[3, 3, 3]}>
                    <InputControl
                        isValidate={isCurrentFormValid}
                        isMandatory={true}
                        name="fathersName"
                        onChange={handlePersonalDetailsChanged}
                        value={personalDetailsValues?.fathersName}
                        placeholder="Enter your father’s full name"
                        hindiLabel={Regisration_Form_Labels_Hindi.FATHERS_NAME}
                        englishLabel={Regisration_Form_Labels_English.FATHERS_NAME}
                    />
                </GridItem>

                <GridItem order={[4, 5, 4]}>
                    <MenuSelect
                        isValidate={isCurrentFormValid}
                        isMandatory={true}
                        onSelect={handlePersonalDetailsChanged}
                        name="maritalStatus"
                        value={personalDetailsValues?.maritalStatus}
                        placeholder="Select your marital status"
                        hindiLabel={Regisration_Form_Labels_Hindi.MARITAL_STATUS}
                        englishLabel={Regisration_Form_Labels_English.MARITAL_STATUS}
                        values={Object.values(MaritalStatus)}
                    />
                </GridItem>

                <GridItem order={[5, 4, 5]}>
                    <MenuSelect
                        isValidate={isCurrentFormValid}
                        isMandatory={true}
                        name="gender"
                        onSelect={handlePersonalDetailsChanged}
                        value={personalDetailsValues?.gender}
                        placeholder="Select your gender"
                        hindiLabel={Regisration_Form_Labels_Hindi.GENDER}
                        englishLabel={Regisration_Form_Labels_English.GENDER}
                        values={Object.values(Genders)}
                    />
                </GridItem>

                {/* <GridItem order={[6, 6, 6]}>
                    <InputControl
                        isNumber={true}
                        length={12}
                        onChange={handlePersonalDetailsChanged}
                        name="aadhaarCardNumber"
                        value={personalDetailsValues?.aadhaarCardNumber}
                        placeholder="Enter your 12 digit Aadhaar number"
                        hindiLabel={Regisration_Form_Labels_Hindi.AADHAR_CARD_NUMBER}
                        englishLabel={Regisration_Form_Labels_English.AADHAR_CARD_NUMBER}
                    />
                </GridItem> */}

                <GridItem order={[6, 6, 6]}>
                    <DatePicker
                        isValidate={isCurrentFormValid}
                        isMandatory={true}
                        hindiLabel={Regisration_Form_Labels_Hindi.BIRTH_DATE}
                        englishLabel={Regisration_Form_Labels_English.BIRTH_DATE}
                        name="dateOfBirth"
                        placeholder="Select your date of birth"
                        selectedDate={personalDetailsValues.dateOfBirth}
                        onDateChange={handlePersonalDetailsChanged}
                    />
                </GridItem>

                <GridItem order={[8, 8, 8]}>
                    <MultiSelect
                        placeholder="Select Interest in Joining Our Community"
                        name="joiningInterest"
                        dropdownValues={interestDropdownValues}
                        value={personalDetailsValues.joiningInterest}
                        onChange={handlePersonalDetailsChanged}
                        hindiLabel={HindiLabels.Community_Joining_Que}
                        englishLabel={EnglishLabels.Community_Joining_Que}
                    />
                </GridItem>
            </SimpleGrid>
        </VStack>
    );
}

export default PersonalDetails;